import { IncidentAttributeId } from '@collector/sportsapi-client-legacy'

import {
  getAttributeId,
  OnSelectOptions,
} from '../../composables/useSportOptions'

export function onSelectTechniqueOfShot<T extends IncidentAttributeId>(
  opts: OnSelectOptions<T>,
  firstTouchAttributeId: T,
): void {
  const {
    addAttribute,
    attributes,
    removeAttribute,
    selectedAttributes,
    toggleAttribute,
    attributeId,
  } = opts
  if (attributeId === firstTouchAttributeId) {
    toggleAttribute(firstTouchAttributeId)
    return
  }
  if (selectedAttributes.value.includes(attributeId)) {
    removeAttribute(attributeId)
    return
  }

  attributes.forEach((attr) => removeAttribute(getAttributeId(attr)))

  addAttribute(attributeId)
}

export function onSelectTechniqueOfShotDetails<T extends IncidentAttributeId>(
  opts: OnSelectOptions<T>,
  exclusivePairs: [T, T?][],
): void {
  const { removeAttribute, toggleAttribute, attributeId } = opts
  const pair = exclusivePairs.find(([a]) => a === attributeId)
  if (pair) {
    toggleAttribute(pair[0])
    if (pair[1]) {
      removeAttribute(pair[1])
    }
  }
}
